import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { createMigrate, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { VARIANT_UI } from 'constants/ui';
import NotificationsService from 'services/notifications/NotificationsService';
import { initAuthStorageSync } from 'services/auth/syncTabs';

import { migrations } from './migrations';
import { rootReducer } from './rootReducer';
import rootSaga from './rootSaga';

const rootPersistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'customers',
    'orders',
    'partTypes',
    'rfqs',
    'jobs',
    'templates',
    'notifications',
    'metadata',
  ],
  version: 6,
  migrate: createMigrate(migrations, { debug: false }),
};

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

const sagaMiddleware = createSagaMiddleware({
  onError: (error) => {
    NotificationsService.throwNotification({
      title: 'Error!',
      text: error?.message || String(error),
      variant: VARIANT_UI.danger,
    });
  },
});

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [sagaMiddleware],
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

initAuthStorageSync(store);

sagaMiddleware.run(rootSaga);
